import Spinner from "./Spinner";

const LoadingState = () => (
  <div className="flex items-center justify-center py-16">
    <Spinner />
  </div>
);

export default LoadingState;
